"use client";

import { ReactNode } from "react";
import { usePathname } from "next/navigation";

// Routes under these base paths will NOT be constrained to the app-frame size
const FRAME_EXCLUDE_ROUTES = [
  "/admin-page", // e.g., admin dashboards and analytics
  "/",           // Landing page renders full-width
  "/blog",       // Public blog renders full-width for readability + SEO
];

const matchesRoute = (pathname: string, route: string) => {
  if (route === "/") return pathname === "/";
  return pathname === route || pathname.startsWith(`${route}/`);
};

export default function ResponsiveFrame({ children }: { children: ReactNode }) {
  const pathname = usePathname() ?? "/";
  const isExcluded = FRAME_EXCLUDE_ROUTES.some((route) =>
    matchesRoute(pathname, route)
  );

  if (isExcluded) {
    // Render without the .app-frame-host wrapper to avoid inherited constraints
    return <div className="min-h-[100svh] w-full">{children}</div>;
  }

  return (
    <div className="app-frame-host">
      <div className="app-frame">{children}</div>
    </div>
  );
}
